import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ marginBottom }) => marginBottom ?? 24}px;

  margin-top: ${({ marginTop }) => marginTop}px;

  * {
    margin: 0;
  }

  .titles-container {
    display: flex;
    flex-direction: column;
  }

  .title {
    font-size: 28px;
    font-weight: bold;
    line-height: 32px;

    color: ${({ tema }) => tema?.primaryColor};
  }

  .subtitle {
    font-size: 18px;
    line-height: 24px;
    color: #4d4d4d;
    margin-top: 12px;

    line-height: 28px;
  }

  button {
    min-width: 126px;
  }

  @media (max-width: 768px) {
    margin-top: ${({ mobileMarginTop }) => mobileMarginTop ?? 0}px;

    .title {
      font-size: 24px;
      line-height: 30px;
    }

    .subtitle {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;
